<cas-confirm-dialog-container [dialogRef]="dialogRef" [data]="data" >
    {{data.message}}
    <div *ngIf="data.displayLoading">
        <br>
        <cas-loading></cas-loading>
    </div>
</cas-confirm-dialog-container>
